var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.takeDialog()}}},[_vm._v("Nehmen / zum Chat")])])}
var staticRenderFns = []

export { render, staticRenderFns }